import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-not-logged-topbar',
    templateUrl: './not-logged-topbar.component.html',
    styleUrls: ['./not-logged-topbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotLoggedTopbarComponent {}
